import { Card } from "antd";
import styles from "./style.module.scss";
import { Button } from "../../custom";
import { useQuery } from "@tanstack/react-query";
import { verifyEmail } from "../../utils/auth_request";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const userId = queryParams.get("userId") ?? "";
  const token = queryParams.get("token") ?? "";
  const email = queryParams.get("email") ?? "";

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["verify-email", userId, token],
    queryFn: () => verifyEmail(userId, token),
  });

  return (
    <section className={styles.container}>
      <div>
        <Card>
          <div className={styles.cardChild}>
            <div>
              <h3>Verify Email</h3>
            </div>

            <div>
              {token ? (
                <>
                  {isLoading ? (
                    <p>Verifying your email, please wait...</p>
                  ) : isError ? (
                    <p>
                      {`Error verifying email: ${
                        (error as any)?.response?.data?.message ||
                        "Unknown error"
                      }`}
                    </p>
                  ) : (
                    <p>
                      Your email has been successfully verified. You can now log
                      in to your account.
                    </p>
                  )}
                </>
              ) : (
                <p>
                  A verification link has been sent to{" "}
                  {email ? email : "your email address"}. Please check your
                  inbox to verify your email.
                </p>
              )}
            </div>
            <br />
            <Button
              text="Back to Login"
              onClick={() => navigate(routes.auth.login)}
            />
          </div>
        </Card>
      </div>
    </section>
  );
};

export default VerifyEmail;
